module.exports = __webpack_public_path__ + "img/Owners icon.8291bd5.png";